import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Person } from '../beans/Person';
import { urlLinks } from '../utility/url-links';
import { HttpService } from './http.service';

@Injectable()
export class PersonService {

	constructor(private http: HttpService) { }

	/** Добавя или обновява човек */
	savePerson(personObj: Person): Observable<any> {
		if (personObj.id) {
			// UPDATE
			return this.http.post<any>(
				urlLinks.rest.person.updatePerson,
				personObj
			);
		} else {
			// CREATE
			return this.http.post<any>(
				urlLinks.rest.person.addPerson,
				personObj
			);
		}
	}

	/** Връща всички хора */
	getPersons(): Observable<Person[]> {
		return this.http.get<any>(urlLinks.rest.person.getPersons).map(page => page && page.content ? page.content : page);
	}

	/** Търси хора по част от име / ЕГН / телефон */
	searchPersons(searchString: string): Observable<Person[]> {
		return this.http.get<Person[]>(
			urlLinks.rest.person.findByPart + encodeURIComponent(searchString)
		);
	}
}
